import './employers-add-form.css'
import { Component } from 'react';

class EmployersAddForm extends Component {
    constructor (props) {
        super(props);
        this.state = {
            name: "",
            salary: ""
        }
    }

    onValueChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }


    render() {
        const {name, salary} = this.state;
        return (     
            <div className="app-add-form">
                <h3>Добавьте нового сотрудника</h3>
                <form onSubmit={(e)=> {
                    e.preventDefault()
                    this.props.onAdd(name, salary)
                    this.setState({
                        name: '',
                        salary: ''
                    })
                }}
                    className="add-form d-flex">
                    <input type="text"
                        className="form-control new-post-label"
                        placeholder="Как его зовут?" 
                        required
                        name= "name"
                        value={name}
                        onChange = {this.onValueChange}/>
                    <input type="number"
                        className="form-control new-post-label"
                        placeholder="З/П в $?"
                        name = "salary"
                        value={salary}
                        required
                        onChange = {this.onValueChange} />
                    <button type="submit"
                            className="btn btn-outline-light"
                            //onClick={this.props.onAdd(name, salary)}
                            >Добавить</button>
                </form>
            </div>
        );
    }
}

export default EmployersAddForm;